import { createTextMask } from 'redux-form-input-masks';

const hourMask = createTextMask({
  pattern: '99:99',
  stripMask: false,
});

export default hourMask;
